// extracted by mini-css-extract-plugin
export default {"selector":"CustomSelectorBox_selector__wT7FY"};